import { LendersPositionWithMapping } from './lenders-position-params'
import { formatNumberToCurrency } from 'app/utils/util-functions'

/**
 * One row of the Positions grid, exactly as `GET /api/positions/screen`
 * returns it: a my-company lender's position on an approved facility, every
 * name resolved, the amounts as numbers with the currency beside them, the
 * past-due flag computed. The three tabs show these same rows with their
 * columns reordered.
 *
 * Not the position record: the drawer fetches its one position's history on
 * open.
 */
export interface PositionsScreenRow {
  /** `${entityId}-${facilityId}` */
  id: string
  dealId: string
  dealClientId: string
  dealName: string
  dealCusip: string
  facilityId: string
  facilityClientId: string
  facilitySystemId: string
  facilityName: string
  facilityType: string
  facilityCusip: string
  facilityLxId: string
  entityId: string
  entityInternalId: string
  entityName: string
  entityMei: string
  agentName: string
  agentMei: string
  opsAdmin: string
  currency: string
  /** The position's latest pro-rata amount ("SD Position"). */
  settledDateAmount: number
  /** The lender's loan positions on this facility, latest amounts summed ("Settled Funded Qty"). */
  sdFunded: number
  classification: string | null
  isPastDue: boolean
}

/**
 * The grid's row, in the shape the three tabs' column defs read: the read's
 * row with the two amounts formatted in the facility's currency (as the page
 * always showed them) and the columns the ledger has no value for yet blank.
 */
export const toGridRow = (row: PositionsScreenRow): LendersPositionWithMapping => {
  const currency = row.currency || 'USD'
  return {
    ...row,
    classification: row.classification ?? undefined,
    settledDateAmount: formatNumberToCurrency(row.settledDateAmount, currency),
    sdFunded: formatNumberToCurrency(row.sdFunded, currency),
    internalName: '',
    tdDate: '',
    strategy: '',
    portfolioManager: '',
  }
}
